import React from "react";
import PropTypes from "prop-types";
import { v4 as uuidv4 } from "uuid";
import "./MultiSelect.scss";

const MultiSelect = props => {
	const uniqueIdentifier = uuidv4();
	return (
		<button
			onClick={() => props.setFilter(props.value)}
			onKeyDown={e => {
				if (e.key === "Enter" || e.key === " ") {
					props.setFilter(props.value);
				}
			}}
			type={"button"}
			tabIndex={0}
			id="hpmt-multiselect">
			<label className={`hpm-filterItem ${props.useLargeLabel ? "useLargeLabel" : ""}`}
				   htmlFor={uniqueIdentifier}
			>
				<span className="hpm-selectText" id="hpmt-selectLabel">
					{props.label}
				</span>
				<span className="hpm-infoText">
					{props.infoText}
				</span>
				<span className={props.selected ? "hpm-checkedSelect hpm-selectDot" : "hpm-selectDot"}
					  id="hpmt-selectDot">
					<span/>
				</span>
			</label>
			<input
				type="checkbox"
				id={uniqueIdentifier}
				checked={props.selected || false}
				onChange={() => props.setFilter(props.value)}
				aria-labelledby="hpmt-selectLabel"
			/>
		</button>
	);
};

MultiSelect.propTypes = {
	label: PropTypes.string.isRequired,
	useLargeLabel: PropTypes.bool,
	infoText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]),
	selected: PropTypes.bool,
	setFilter: PropTypes.func.isRequired
};

export default MultiSelect;
